import React, { useState } from "react";
import axios from "axios";
import "../../index.css";
import OtherPageTopBanner from "../../Herosection/Components/OtherPageTopBanner";

function Enquiry() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    enquiryType: '',
    propertyType: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("http://localhost:5000/api/enquiry", formData);
      alert(res.data.message || "Enquiry sent successfully!");
      setFormData({
        name: '',
        phone: '',
        email: '',
        address: '',
        enquiryType: '',
        propertyType:'',
        message: ''
      }); // Clear form
    } catch (error) {
      alert("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  return (
    <>
      <OtherPageTopBanner title="ENQUIRY" />

      <div className="container-fluid px-md-5 py-5">
        <div data-aos="zoom-in" data-aos-duration="1500">
          <h6 className="text-center text-secondary">Enquiry</h6>
          <h2 className="text-center text-primary mb-5">Enquiry Now</h2>
        </div>

        <div className="contactus tece">
          {/* Enquiry Form */}
          <div className="row d-flex justify-content-center">
            <div className="col-md-8 col-sm-11">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                    <input
                      type="text"
                      name="name"
                      className="form-control p-3 border-primary"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control p-3 border-primary"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                    <input
                      type="email"
                      name="email"
                      className="form-control p-3 border-primary"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                    <input
                      type="text"
                      name="address"
                      className="form-control p-3 border-primary"
                      placeholder="Address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                    <select
                      name="enquiryType"
                      className="form-control p-3 border-primary"
                      value={formData.enquiryType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">SELECT ENQUIRY TYPE</option>
                      <option value="AC Installation">AC Installation</option>
                      <option value="AC Maintenance">AC Maintenance</option>
                      <option value="AC Repair">AC Repair</option>
                      <option value="New AC Purchase">New AC Purchase</option>
                      <option value="Annual Maintenance Contract">Annual Maintenance Contract</option>

                    </select>
                  </div>



                  <div className="col-md-12" data-aos="fade-up" data-aos-duration="1500">
                  <select
  name="propertyType"
  className="form-control p-3 border-primary"
  value={formData.propertyType}
  onChange={handleChange}
  required
>
  <option value="">Type of Property</option>
  <option value="Residential">Residential</option>
  <option value="Commercial">Commercial</option>
  <option value="Industrial">Industrial</option>
</select>

                  </div>
                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control p-3 border-primary"
                      rows="5"
                      placeholder="Drop your message.."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary p-3 w-100">
                      Send Enquiry
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Enquiry;
